/**
 * DATABANK COLUMNS
 * Special handling - uses ICR mapping
 */

import icrMappingData from '../cell_data/icrMapping.json';

export const ICR_MAPPING: { [key: string]: string[] } = icrMappingData;
export const ALL_ICRS = Object.keys(ICR_MAPPING);

export const getInvertersForICR = (icr: string): string[] => {
  return ICR_MAPPING[icr] || [];
};

export const calculateICRSum = (
  icr: string,
  date: string,
  data: { [icr: string]: { [date: string]: { [inverter: string]: string } } }
): number => {
  const inverters = getInvertersForICR(icr);
  return inverters.reduce((sum, inv) => {
    const raw = data[icr]?.[date]?.[inv];
    return sum + (parseFloat(raw || '') || 0);
  }, 0);
};
